import { getAuthToken } from './auth.js';
import { apiBaseUrl } from '../../backend/config.js';
import { t, confirmT, updateElementText } from './translationHelper.js';
import translations from './translations.js';

if (!globalThis.ZTranslations) {
  globalThis.ZTranslations = translations;
}

if (typeof globalThis.$t !== 'function') {
  globalThis.$t = (key, params) => {
	return t(key);
  };
}

let animationInterval;
let currentMessage = '';
let transAnimationInterval;
let currentTransMessage = '';

const ledFont = {
  'A': ['00100', '01010', '10001', '11111', '10001'],
  'B': ['11110', '10001', '11110', '10001', '11110'],
  'C': ['01110', '10001', '10000', '10001', '01110'],
  'D': ['11110', '10001', '10001', '10001', '11110'],
  'E': ['11111', '10000', '11100', '10000', '11111'],
  'F': ['11111', '10000', '11100', '10000', '10000'],
  'G': ['01110', '10001', '10000', '10011', '01110'],
  'H': ['10001', '10001', '11111', '10001', '10001'],
  'I': ['11111', '00100', '00100', '00100', '11111'],
  'J': ['00111', '00010', '00010', '10010', '01100'],
  'K': ['10001', '10010', '11100', '10010', '10001'],
  'L': ['10000', '10000', '10000', '10000', '11111'],
  'M': ['10001', '11011', '10101', '10001', '10001'],
  'N': ['10001', '11001', '10101', '10011', '10001'],
  'O': ['01110', '10001', '10001', '10001', '01110'],
  'P': ['11110', '10001', '11110', '10000', '10000'],
  'Q': ['01110', '10001', '10101', '10010', '01101'],
  'R': ['11110', '10001', '11110', '10010', '10001'],
  'S': ['01111', '10000', '01110', '00001', '11110'],
  'T': ['11111', '00100', '00100', '00100', '00100'],
  'U': ['10001', '10001', '10001', '10001', '01110'],
  'V': ['10001', '10001', '10001', '01010', '00100'],
  'W': ['10001', '10001', '10101', '10101', '01010'],
  'X': ['10001', '01010', '00100', '01010', '10001'],
  'Y': ['10001', '01010', '00100', '00100', '00100'],
  'Z': ['11111', '00010', '00100', '01000', '11111'],
  '0': ['01110', '10001', '10001', '10001', '01110'],
  '1': ['00100', '01100', '00100', '00100', '01110'],
  '2': ['01110', '10001', '00010', '00100', '11111'],
  '3': ['11110', '00001', '00110', '00001', '11110'],
  '4': ['00010', '00110', '01010', '11111', '00010'],
  '5': ['11111', '10000', '11110', '00001', '11110'],
  '6': ['01110', '10000', '11110', '10001', '01110'],
  '7': ['11111', '00001', '00010', '00100', '00100'],
  '8': ['01110', '10001', '01110', '10001', '01110'],
  '9': ['01110', '10001', '01111', '00001', '01110'],
  ' ': ['00000', '00000', '00000', '00000', '00000'],
  '!': ['00100', '00100', '00100', '00000', '00100'],
  '.': ['00000', '00000', '00000', '00000', '00100'],
  ',': ['00000', '00000', '00000', '00010', '00100'],
  "'": ['00100', '00100', '00000', '00000', '00000'],
  '"': ['01010', '01010', '00000', '00000', '00000'],
  '(': ['00010', '00100', '00100', '00100', '00010'],
  ')': ['00100', '00010', '00010', '00010', '00100'],
  '+': ['00000', '00100', '01110', '00100', '00000'],
  '-': ['00000', '00000', '01110', '00000', '00000'],
  '?': ['01110', '10001', '00010', '00000', '00100'],
  ':': ['00000', '00000', '00100', '00000', '00100'],
  '|': ['00100', '00100', '00100', '00100', '00100'],
  'À': ['00100', '01010', '10001', '11111', '10001'],
  'Â': ['00100', '01010', '10001', '11111', '10001'],
  'Ä': ['01010', '00000', '10001', '11111', '10001'],
  'Ç': ['01110', '10001', '10000', '10001', '11100'],
  'É': ['00100', '01110', '10000', '11100', '10000'],
  'È': ['00100', '10000', '11100', '10000', '11111'],
  'Ê': ['01010', '10000', '11100', '10000', '11111'],
  'Ë': ['01010', '00000', '11111', '10000', '11111'],
  'Î': ['01010', '00100', '11111', '00100', '00100'],
  'Ï': ['01010', '00000', '11111', '00100', '00100'],
  'Ô': ['01010', '10001', '10001', '10001', '01110'],
  'Ö': ['01010', '00000', '01110', '10001', '01110'],
  'Ù': ['00100', '10001', '10001', '10001', '01110'],
  'Û': ['01010', '10001', '10001', '10001', '01110'],
  'Ü': ['01010', '00000', '10001', '10001', '01110'],
  'à': ['00010', '00001', '01111', '10001', '01111'],
  'â': ['00100', '01010', '01110', '10001', '01111'],
  'ä': ['01010', '00000', '01110', '10001', '01111'],
  'ç': ['00000', '01110', '10000', '10001', '01110'],
  'é': ['00100', '01110', '10001', '11111', '10000'],
  'è': ['00100', '10001', '11111', '10000', '01110'],
  'ê': ['01010', '01110', '10001', '11111', '10000'],
  'ë': ['01010', '00000', '01110', '10001', '11110'],
  'î': ['00100', '00000', '01100', '00100', '11110'],
  'ï': ['01010', '00000', '00100', '00100', '00100'],
  'ô': ['01010', '00000', '01110', '10001', '01110'],
  'ö': ['01010', '00000', '01110', '10001', '01110'],
  'ù': ['00100', '00001', '10001', '10011', '01101'],
  'û': ['01010', '00001', '10001', '10011', '01101'],
  'ü': ['01010', '00000', '10001', '10001', '01111'],
  'œ': ['00000', '01110', '10111', '10100', '01111']
};

export function addNotificationStyles() {
  const styles = `
  .notification {
	position: fixed;
	bottom:120px;
	right:10px;
	margin: 0px auto;
	text-align: center;
	background-color: rgba(0, 255, 0, 0.849);
	border: 1px solid #00ff00;
	color: #000000;
	padding: 10px 20px;
	border-radius: 5px;
	z-index: 1000;
	animation: fadeInOut 3s ease-in-out;
  }

  .notification.success {
	border-color: #28a745;
	color: #000000;
  }

  .notification.fail {
	border-color: #dc3545;
	color: #dc3545;
  }

  @keyframes fadeInOut {
	0% { opacity: 0; transform: translateY(-20px); }
	10% { opacity: 1; transform: translateY(0); }
	90% { opacity: 1; transform: translateY(0); }
	100% { opacity: 0; transform: translateY(-20px); }
  }
  .portfolio-search-container{
	 width: 100%;
	 height: auto; 
	 padding: 5px 0px 5px 10px;
	 margin-top: 5px;	
	}
	.portfolio-search-container input{
	background-color: rgba(36, 65, 192, 0.792);
	 color: #00ff00;
	 border: 1px solid rgba(255, 135, 0, 0.682);
	 width: 100%;
	 height: 35px; 
	 padding: 5px 0px 5px 10px;
	 margin-top: 5px;	
	}
	
  `;

  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

export const showNotification = (message, isSuccess) => {
  const ledBoard = document.createElement('div');
  ledBoard.className = 'led-board';
  ledBoard.style = `
	position: fixed;
	bottom: 8%;
	left: -100%;
	width: 100%;
	max-width: 100%;
	height: 42px;
	display: grid;
	grid-template-columns: repeat(150, 4px);
	grid-gap: 2px;
	background-color: ${isSuccess ? 'rgba(0, 30, 0, 0.97)' : 'rgba(30, 0, 0, 0.97)'};
	padding: 6px;
	border-radius: 4px;
	border: 2px solid ${isSuccess ? '#00ff00' : '#ff0000'};
	z-index: 10001;
	overflow: hidden;
	transition: left 0.5s ease-in-out;
  `;

  for (let i = 0; i < 150 * 5; i++) {
	const led = document.createElement('div');
	led.className = 'led';
	led.style = `
	  width: 6px;
	  height: 6px;
	  background-color: ${isSuccess ? '#003300' : '#330000'};
	  border-radius: 50%;
	  transition: background-color 0.1s, box-shadow 0.1s;
	`;
	ledBoard.appendChild(led);
  }

  document.body.appendChild(ledBoard);

  // Trigger the slide-in effect
  setTimeout(() => {
	ledBoard.style.left = '1%';
  }, 10);

  const drawText = (text) => {
	const leds = ledBoard.querySelectorAll('.led');
	let offset = 0; // Start from the beginning of the board

	const animationInterval = setInterval(() => {
	  offset++;
	  if (offset > text.length * 6) {
		offset = 0; // Reset to create a loop effect
	  }

	  for (let row = 0; row < 5; row++) {
		for (let col = 0; col < 150; col++) {
		  const index = row * 150 + col;
		  const charIndex = Math.floor((col + offset) / 6);
		  const char = text[charIndex % text.length]; // Use modulo to loop the text
		  const fontCol = (col + offset) % 6;

		  if (char && fontCol < 5 && ledFont[char]) {
			const isLit = ledFont[char][row][fontCol] === '1';
			if (isLit) {
			  leds[index].style.backgroundColor = isSuccess ? '#00ff00' : '#ff0000';
			  leds[index].style.boxShadow = isSuccess ? '0 0 4px #00ff00' : '0 0 4px #ff0000';
			} else {
			  leds[index].style.backgroundColor = isSuccess ? '#003300' : '#330000';
			  leds[index].style.boxShadow = 'none';
			}
		  } else {
			leds[index].style.backgroundColor = isSuccess ? '#003300' : '#330000';
			leds[index].style.boxShadow = 'none';
		  }
		}
	  }
	}, 20); // Keep the animation speed

	// Remove the notification after 6 seconds
	setTimeout(() => {
	  ledBoard.style.left = '-100%'; // Slide out
	  clearInterval(animationInterval); // Stop the animation
	  setTimeout(() => ledBoard.remove(), 700); // Remove after slide-out
	}, 6000);
  };

  // Add extra spaces to create a gap between repetitions
  drawText(message.toUpperCase() + '        ');
};

function injectLedPopupStyles() {
  if (document.getElementById('led-popup-styles')) return;
  const style = document.createElement('style');
  style.id = 'led-popup-styles';
  style.textContent = `
	#led-popup {
	  position: fixed;
	  inset: 5% 5% auto 5%;
	  width: 90%;
	  height: 90%;
	  display: flex;
	  flex-direction: column;
	  background: radial-gradient(1200px 600px at 20% 0%, rgba(0, 15, 10, 0.96), rgba(0, 2, 9, 0.94) 60%);
	  border: 1px solid rgba(255,255,255,0.12);
	  border-radius: 10px;
	  box-shadow: 0 6px 18px rgba(0,0,0,0.45);
	  z-index: 10001;
	  overflow: auto;
	  box-sizing: border-box;
	  backdrop-filter: blur(2px);
	  padding: 8px;
	  animation: ledPopupIn .18s ease-out;
	}
	@keyframes ledPopupIn {
	  from { transform: scale(0.992); opacity: .0 }
	  to   { transform: scale(1);     opacity: 1  }
	}

	/* === Hard reset table layout INSIDE the popup (beats global tr { display:flex } ) === */
	#led-popup table.led-table { display: table !important; width: 100%; border-collapse: collapse !important; table-layout: fixed !important; }
	#led-popup table.led-table thead { display: table-header-group !important; }
	#led-popup table.led-table tbody { display: table-row-group !important; }
	#led-popup table.led-table tr { display: table-row !important; height: auto !important; justify-content: normal !important; align-items: normal !important; }
	#led-popup table.led-table td, 
	#led-popup table.led-table th { display: table-cell !important; vertical-align: middle !important; }

	/* Compact, neutral look */
	#led-popup table.led-table {
	  margin: 0 0 8px 0 !important;
	  color: #e9fff6 !important;
	  font-family: 'bithigh', monospace !important;
	  font-size: 13px !important;
	  line-height: 1.25 !important;
	}
	#led-popup table.led-table col.label-col { width: 45% !important; }
	#led-popup table.led-table col.value-col { width: 55% !important; }

	#led-popup table.led-table td {
	  padding: 15px !important;  /* EXACTLY 5px */
	  border: none !important;
	  border-bottom: 1px solid rgba(255,255,255,0.12) !important; /* bottom border only */
	  background: transparent !important;
	  word-break: break-word !important;
	}
	#led-popup table.led-table tr:first-child td { border-top: none !important; }

	#led-popup table.led-table td.label {
	  color: #cfeee4 !important;
	  font-weight: 600 !important;
	  text-overflow: ellipsis !important;
	  overflow: hidden !important;
	  white-space: nowrap !important;
	}
	#led-popup table.led-table td.value {
	  color: #2fff29 !important;
	  text-align: right !important;
	}

	/* Zollar block row (spans 2 cols) */
	#led-popup .zolPop { 
	  margin-top: 2px !important; 
	  padding: 0 !important; 
	  color: #e4fff6 !important; 
	  font-size: 13px !important; 
	  line-height: 1.25 !important; 
	  text-shadow: none !important; 
	}
	#led-popup .zolPop br { line-height: 1.1 !important; }
	td::before {
		content: attr(data-title);
		color: #fff;
		text-align: center;
		z-index: 1;
		background-color: #00ff001a;
		border-radius: 1px;
		margin-bottom: 10px;
		padding: 5px;
		font-size: .9rem;
		font-weight: 700;
		display: block;
		position: relative;
	  }
	#led-popup .led-close {
	  margin-top: 8px;
	  align-self: flex-end;
	  padding: 8px 12px;
	  background: red;
	  width: 100%;
	  border: 1px solid rgba(255,255,255,0.18);
	  border-radius: 6px;
	  cursor: pointer;
	  color: #ffffff;
	  font-family: 'bithigh', monospace;
	  font-size: 12px;
	  letter-spacing: .04em;
	  transition: transform .08s ease, box-shadow .12s ease, background .12s ease;
	}
	#led-popup .led-close:hover { transform: translateY(-1px); box-shadow: 0 0 10px rgba(255,255,255,0.15); background: rgba(110,110,110,0.32); }
  `;
  document.head.appendChild(style);
}


export function updateTotalPointsDisplay(
  totalPoints,
  portfolioData = null,
  itemCumulativePoints = null,
  stockCumulativeValue = null,
  shortPositionTotalGainLoss = null,
  zollars = null,
  debtData = null
) {
  const totalPointsElement = document.getElementById('total-points');
  if (!totalPointsElement) return;

  // Localized labels
  const L = {
	totalFunds:        t('LedHold.total_funds',       'Total Holdings'),
	earnedFunds:       t('LedHold.earned_funds',      'Capital Z'),
	itemsValue:        t('LedHold.value_items',       'Items Value'),
	stockValue:        t('LedHold.value_stock',       'Stock Value'),
	shortPosition:     t('LedHold.value_short',       'Short Position'),
	zollars:           t('LedHold.zollars',           'Zollars'),
	debtOwed:          t('LedHold.debt_owed',         'Debt Owed'),
	debtHeld:          t('LedHold.debt_held',         'Debt Held'),
  };

  // Base line (LED)
  let newMessage  = `${L.totalFunds}: ${totalPoints.toFixed(2)}`;
  // Popup message mirrors LED, but can include HTML blocks
  let popupMessage = newMessage;

  if (
	portfolioData &&
	itemCumulativePoints !== null &&
	stockCumulativeValue !== null &&
	shortPositionTotalGainLoss !== null
  ) {
	const details =
	  ` | ${L.earnedFunds}: ${portfolioData.tradingPoints.toFixed(2)}` +
	  ` | ${L.itemsValue}: ${itemCumulativePoints.toFixed(2)}` +
	  ` | ${L.stockValue}: ${stockCumulativeValue.toFixed(2)}` +
	  ` | ${L.shortPosition}: ${shortPositionTotalGainLoss.toFixed(2)}`;
	newMessage  += details;
	popupMessage += details;
  }

  if (Array.isArray(zollars)) {
	const relationshipTotals = {};
	zollars.forEach((z) => {
	  const type = String(z.zollar_name || '')
		.replace('Zollar', '')
		.trim()
		.toLowerCase();
	  if (!type) return;
	  relationshipTotals[type] = (relationshipTotals[type] || 0) + 1;
	});

	// Plain text summary for the ticker
	const zollarDetailsPlain = Object.entries(relationshipTotals)
	  .map(([type, count]) => {
		const typeLabel = t(
		  `LedHold.zollarType.${type}`,
		  capitalizeFirstLetter(type)
		);
		return `${typeLabel}: ${getQualitativeDescriptor(count)}`;
	  })
	  .join(', ');
	newMessage += ` | ${L.zollars}: ${zollarDetailsPlain}`;

	// HTML block for the popup
	const zollarDetailsHtml = Object.entries(relationshipTotals)
	  .map(([type, count]) => {
		const typeLabel = t(
		  `LedHold.zollarType.${type}`,
		  capitalizeFirstLetter(type)
		);
		return `${typeLabel}: ${getQualitativeDescriptor(count)}`;
	  })
	  .join(', <br>');
	popupMessage +=
	  ` | <div class="zolPop"><strong>${L.zollars}:&nbsp;</strong>${zollarDetailsHtml}</div>`;
  }

  // Display debt information
  if (debtData && debtData.success) {
	const debtOwed = debtData.totalDebtOwed || 0;
	const debtHeld = debtData.totalDebtHeld || 0;

	// Plain text for LED ticker
	if (debtOwed > 0) newMessage += ` | ${L.debtOwed}: ${debtOwed.toFixed(2)}`;
	if (debtHeld > 0) newMessage += ` | ${L.debtHeld}: ${debtHeld.toFixed(2)}`;

	// HTML block for popup with multi-line details
	if (debtOwed > 0 || debtHeld > 0) {
	  const debtLines = [];
	  if (debtOwed > 0) {
		debtLines.push(
		  `<span style="color:#ff6666;">${L.debtOwed}: ${debtOwed.toFixed(
			2
		  )}</span>`
		);
	  }
	  if (debtHeld > 0) {
		debtLines.push(
		  `<span style="color:#66ff66;">${L.debtHeld}: ${debtHeld.toFixed(
			2
		  )}</span>`
		);
	  }
	  if (debtData.netDebt !== undefined) {
		const netColor =
		  debtData.netDebt > 0
			? '#ff6666'
			: debtData.netDebt < 0
			? '#66ff66'
			: '#fcba03';
		debtLines.push(
		  `<span style="color:${netColor};">Net Position: ${debtData.netDebt.toFixed(
			2
		  )}</span>`
		);
	  }
	  const debtDetailsHtml =
		`<strong>Debt:</strong><br>${debtLines.join('<br>')}`;
	  popupMessage += ` | <div class="debtPop">${debtDetailsHtml}</div>`;
	}
  }

  // Only update if message changed
  if (window.currentMessage === newMessage) return;
  window.currentMessage = newMessage;
  window.currentPopupMessage = popupMessage;

  // --- LED sizing: lettering is good, adjust container below ---

  const DOT_SPACING = 12;   // distance between dot centers
  const DOT_RADIUS  = 3.8;  // dot radius
  const CHAR_COLS   = 5;
  const CHAR_ROWS   = 5;   // original 10-row font matrix

  const CHAR_PIXEL_WIDTH  = DOT_SPACING * CHAR_COLS;   // 12 * 5 = 60
  const CHAR_PIXEL_HEIGHT = DOT_SPACING * CHAR_ROWS;   // 12 * 10 = 120

  const CHAR_GAP   = 18;                               // extra empty space between characters
  const CHAR_STEP  = CHAR_PIXEL_WIDTH + CHAR_GAP;      // scroll step per character

  // Trim some bottom space from the bitmap so container is not too tall
  const BOTTOM_TRIM = 0; // adjust 20–30 if needed

  // Create canvas only once
  let canvas = totalPointsElement.querySelector('canvas');
  if (!canvas) {
	canvas = document.createElement('canvas');
	canvas.width  = 800;
	canvas.height = CHAR_PIXEL_HEIGHT + 10;    // smaller visible container
	canvas.style.width  = '100%';
	canvas.style.paddingTop = '0px';
	canvas.style.height = `${canvas.height}px`;
	canvas.style.cursor = 'pointer';

	totalPointsElement.innerHTML = '';
	totalPointsElement.appendChild(canvas);

	canvas.addEventListener('click', () =>
	  showPopupPoints(window.currentPopupMessage)
	);
  } else {
	canvas.height = CHAR_PIXEL_HEIGHT - BOTTOM_TRIM;
	canvas.style.height = `${canvas.height}px`;
  }

  // Rebuild LED patterns for current sizing/message
  window.ledPatterns = new Map();
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width  = CHAR_PIXEL_WIDTH;
  tempCanvas.height = CHAR_PIXEL_HEIGHT;
  const tempCtx = tempCanvas.getContext('2d');

  for (const char of new Set(newMessage.toUpperCase())) {
	if (!ledFont[char]) continue;
	tempCtx.clearRect(0, 0, CHAR_PIXEL_WIDTH, CHAR_PIXEL_HEIGHT);

	for (let row = 0; row < CHAR_ROWS; row++) {
	  for (let col = 0; col < CHAR_COLS; col++) {
		if (ledFont[char][row] && ledFont[char][row][col] === '1') {
		  tempCtx.fillStyle = '#fcba03';
		  tempCtx.beginPath();
		  tempCtx.arc(
			col * DOT_SPACING + DOT_SPACING / 2,
			row * DOT_SPACING + DOT_SPACING / 2,
			DOT_RADIUS,
			0,
			Math.PI * 2
		  );
		  tempCtx.fill();
		}
	  }
	}

	window.ledPatterns.set(
	  char,
	  tempCtx.getImageData(0, 0, CHAR_PIXEL_WIDTH, CHAR_PIXEL_HEIGHT)
	);
  }

  const ctx = canvas.getContext('2d');
  let animationFrame;
  let offset = 0;
  const SCROLL_SPEED = 4;

  if (window.stopAnimation) window.stopAnimation();

  function animate() {
	ctx.clearRect(0, 0, canvas.width, canvas.height);

	const visibleChars = Math.ceil(canvas.width / CHAR_STEP) + 2;
	const startChar = Math.floor(offset / CHAR_STEP);

	for (let i = 0; i < visibleChars; i++) {
	  const charIndex = (startChar + i) % newMessage.length;
	  const char = newMessage[charIndex].toUpperCase();
	  const pattern = window.ledPatterns.get(char);

	  if (pattern) {
	  const x = i * CHAR_STEP - (offset % CHAR_STEP);
		// center vertically: (canvas.height - pattern.height) / 2
		const y = Math.round((canvas.height - CHAR_PIXEL_HEIGHT) / 2);
		ctx.putImageData(pattern, x, y);
	  }
	}

	offset = (offset + SCROLL_SPEED) % (newMessage.length * CHAR_STEP);
	animationFrame = requestAnimationFrame(animate);
  }

  window.stopAnimation = () => {
	if (animationFrame) cancelAnimationFrame(animationFrame);
  };

  animate();
}


// Helper functions for Zollar descriptors and capitalization
function getQualitativeDescriptor(quantity) {
  if (quantity === 0)            return t('LedHold.zollarDescriptor.none', 'None');
  else if (quantity <= 3)        return t('LedHold.zollarDescriptor.few', 'A Few');
  else if (quantity <= 7)        return t('LedHold.zollarDescriptor.some', 'Some');
  else if (quantity <= 15)       return t('LedHold.zollarDescriptor.many', 'Many');
  return t('LedHold.zollarDescriptor.huge', 'A Huge Amount');
}


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function showPopupPoints(message) {
  const existingPopup = document.getElementById('led-popup');
  if (existingPopup) existingPopup.remove();

  injectLedPopupStyles();

  const popup = document.createElement('div');
  popup.id = 'led-popup';

  const table = document.createElement('table');
  table.className = 'led-table';

  // Force two columns with known widths
  const colgroup = document.createElement('colgroup');
  const col1 = document.createElement('col'); col1.className = 'label-col';
  const col2 = document.createElement('col'); col2.className = 'value-col';
  colgroup.appendChild(col1);
  colgroup.appendChild(col2);
  table.appendChild(colgroup);

  const tbody = document.createElement('tbody');
  table.appendChild(tbody);

  // Tokenize by top-level separators (you build message with " | ")
  const parts = String(message || '')
	.split(' | ')
	.map(p => (p || '').trim())
	.filter(Boolean);

  // Reconstruct rows, grouping any HTML blocks like <div class="zolPop"> or <div class="debtPop">
  // until their closing </div>, so inner spans and pipes don't leak.
  const rows = [];
  const popDivRegex = /<div[^>]*class="[^"]*(?:zolPop|debtPop)[^"]*"[^>]*>/i;
  let buffer = null;

  for (let i = 0; i < parts.length; i++) {
	const token = parts[i];

	if (buffer !== null) {
	  buffer += ' | ' + token;
	  if (token.includes('</div>')) {
		rows.push(buffer);
		buffer = null;
	  }
	  continue;
	}

	if (popDivRegex.test(token)) {
	  if (token.includes('</div>')) {
		rows.push(token);            // single-token HTML block
	  } else {
		buffer = token;              // begin buffering until </div>
	  }
	  continue;
	}

	rows.push(token);                // normal label:value row
  }
  if (buffer !== null) rows.push(buffer); // fail-safe

  rows.forEach((row, idx) => {
	const tr = document.createElement('tr');

	// Keep HTML blocks as one row spanning both columns
	if (row.includes('class="zolPop"') || row.includes('class="debtPop"')) {
	  const td = document.createElement('td');
	  td.colSpan = 2;
	  td.className = 'value';
	  td.innerHTML = row;            // render the provided HTML block intact
	  tr.appendChild(td);
	  tbody.appendChild(tr);
	  return;
	}

	// Split only on the first ":" -> Label | Value
	const m = row.match(/^([^:]+)\s*:\s*(.*)$/);
	const label = (m ? m[1] : row).trim();
	const value = (m ? m[2] : '').trim();

	const tdLabel = document.createElement('td');
	tdLabel.className = 'label';
	tdLabel.textContent = label;

	const tdValue = document.createElement('td');
	tdValue.className = 'value';
	tdValue.innerHTML = value || '&nbsp;';

	if (idx === 0) {
	  tdLabel.style.borderTop = 'none';
	  tdValue.style.borderTop = 'none';
	}

	tr.appendChild(tdLabel);
	tr.appendChild(tdValue);
	tbody.appendChild(tr);
  });

  popup.appendChild(table);

  const closeButton = document.createElement('button');
  closeButton.className = 'led-close';
  closeButton.textContent = (typeof t === 'function') ? t('LedHold.close', 'Close') : 'Close';
  closeButton.onclick = () => popup.remove();
  popup.appendChild(closeButton);

  document.body.appendChild(popup);
}









export function clearLEDDisplay() {
  if (animationInterval) {
	clearInterval(animationInterval);
	animationInterval = null;
  }
  const totalPointsElement = document.getElementById('total-points');
  if (totalPointsElement) {
	const label = t('LedHold.total_points_label', 'Total Points');
	totalPointsElement.innerHTML = `${label}: ${currentMessage.split('    ')[0].split('$')[1]}`;
  }
}


	
